import React, { useContext } from "react";
import { QbdCustomFieldsSidebar } from "../QbdCustomFieldsSidebar/QbdCustomFieldsSidebar";
import UiContext from "@contexts/UiContext";
import OwButton from "@components/shared/OwButton/OwButton";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import { OwAccordion } from "@components/shared/OwAccordion/OwAccordion";
import TitleTagEnum from "@models/TitleTagEnum";

type Props = {
    borderClass: string;
};

export const QuickbooksDesktopConfigOtherSection = (props: Props) => {
    const uiContext = useContext(UiContext);

    const closeSidebar = () => {
        uiContext.setSidebarComponent(null);
        uiContext.toggleSidebar(false);
    };

    const editCustomFields = () => {
        const sidebarComponent = <QbdCustomFieldsSidebar closeSidebar={closeSidebar} />;

        uiContext.setSidebarComponent(sidebarComponent);
        uiContext.toggleSidebar(true);
    };

    return (
        <div className={"QuickbooksDesktopConfigOtherSection"}>
            <OwAccordion title={"other"} fullWidthClick={true} titleTag={TitleTagEnum.H5}>
                <div className={"mt-4 col-12 card " + props.borderClass} data-id={"qbd-other-card"}>
                    <div className="card-header">
                        <OwTitle title={"other"} isBold={true} tag={"h5"} />
                    </div>

                    <div className="card-body">
                        <div className="">
                            <OwButton title={"edit_custom_fields"} fn={editCustomFields} />
                        </div>
                    </div>
                </div>
            </OwAccordion>
        </div>
    );
};
